module.exports = __webpack_public_path__ + "img/dot.8aa070fa.svg";